module.exports = __webpack_public_path__ + "img/iconOperatingManual.c81c6e68.svg";